import { render } from "./template-groups.html?vue&type=template&id=ed60c136&scoped=true&ts=true"
import script from "./template-groups.ts?vue&type=script&lang=ts"
export * from "./template-groups.ts?vue&type=script&lang=ts"

import "./template-groups.scss?vue&type=style&index=0&id=ed60c136&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed60c136"]])

export default __exports__